import { type ReactNode, useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import { getWechatBindingPresentation } from '@/components/WechatSignIn/presentation';
import PageMeta from '@/shared/components/PageMeta';
import type { Props as PageMetaProps } from '@/shared/components/PageMeta';
import { getContextualSignInPage } from '@/utils/contextual-sign-in-page';

import styles from './index.module.scss';

type Props = {
  readonly children: ReactNode;
  readonly pageMeta: PageMetaProps;
};

const FirstScreenLayout = ({ children, pageMeta }: Props) => {
  const { platform } = useContext(PageContext);
  const showSpacers =
    platform === 'web' && !getContextualSignInPage() && !getWechatBindingPresentation();

  return (
    <>
      <PageMeta {...pageMeta} />
      {showSpacers && <div className={styles.placeholderTop} />}
      <div className={styles.wrapper}>{children}</div>
      {showSpacers && <div className={styles.placeholderBottom} />}
    </>
  );
};

export default FirstScreenLayout;
